/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_And_ProfileInputs */

const en_ui_delete_dialog_and_profile = /** @type {(inputs: Ui_Delete_Dialog_And_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and your profile`)
};

const de_ui_delete_dialog_and_profile = /** @type {(inputs: Ui_Delete_Dialog_And_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und dein Profil`)
};

/**
* | output |
* | --- |
* | "and your profile" |
*
* @param {Ui_Delete_Dialog_And_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_and_profile = /** @type {((inputs?: Ui_Delete_Dialog_And_ProfileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_And_ProfileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_and_profile(inputs)
	return de_ui_delete_dialog_and_profile(inputs)
});